import React, { Fragment } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { TopTextReusableComponent } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { ReusableOnboardingButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import isEmpty from "../../../../../store/validation/is-Empty";
import Validator from "validator";

const RestaurantChainWrapperComponent = ({ localProps, state, ...props }) => {
  return (
    <Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="col-12 pl-5 pr-5">
              <div className="super_admin_add_vendor mb-4">
                <h5 className="main_header_text">
                  {state?.editActionByAdmin ? "Edit" : "Add"} Vendor
                </h5>
                <h4 className="font_20_m">Step : 5</h4>
                <h4 className="font_20_m c_red mt-2 mb-1">
                  Business Chain Details
                </h4>
                <hr className="hr_line" />
              </div>
              <TopTextReusableComponent
                headingText={
                  state.is_suggest_new_open === true
                    ? "Business Chain Details"
                    : "Business Settings"
                }
                headingParagraph={
                  state.is_suggest_new_open === true
                    ? "Please enter details about your Business chain"
                    : "Enter the details about your Business Establishment"
                }
              />
              <div className="col-6 p-0">
                {props.children}
                <div className="onboarding-map-setup-screen-autodetect-button mt-5">
                  <ReusableOnboardingButton
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    onClick={
                      state.are_you_part_of_chain === false
                        ? () =>
                            props.history.push(
                              state?.editActionByAdmin
                                ? "/admin_edit_restauran_info"
                                : "/addvendorrestauraninfo"
                            )
                        : state.is_suggest_new_open === true
                        ? localProps.onBackButtonSuggestNew
                        : localProps.onBackButtonChainPage
                    }
                  />

                  <ReusableOnboardingButton
                    buttonTitle="Next Button"
                    buttonText="Next"
                    buttonType="button"
                    disabled={errorHandler(state)}
                    onClick={
                      state.actionButton === false
                        ? localProps.onWithOutApiCall
                        : state.are_you_part_of_chain === false
                        ? () =>
                            props.history.push(
                              state?.editActionByAdmin
                                ? "/admin_edit_restaurant_type"
                                : "/addvendorrestauranttype"
                            )
                        : state.is_suggest_new_open === true
                        ? localProps.onSuggestNewSubmitHandler
                        : localProps.onhandleSubmit
                    }
                    buttonClass={`onboarding_button_link_reusable ${
                      errorHandler(state)
                        ? "onboarding_button_link_reusable_gray ml-3"
                        : "onboarding_button_link_reusable_red ml-3"
                    }`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RestaurantChainWrapperComponent;

const errorHandler = (state) => {
  if (state.are_you_part_of_chain === false) {
    return false;
  } else if (state.is_suggest_new_open === true && isEmpty(state.errors)) {
    if (
      state.title === "" ||
      state.address === "" ||
      state.area === "" ||
      state.city === "" ||
      state.phone_numbers[state.phone_numbers.length - 1].mobile_no === "" ||
      state.phone_numbers[state.phone_numbers.length - 1].mobile_no.length <
        10 ||
      state.enquiry_emails[state.enquiry_emails.length - 1] === "" ||
      !Validator.isEmail(
        state.enquiry_emails[state.enquiry_emails.length - 1]
      ) ||
      state.icon.length <= 0
    ) {
      return true;
    } else {
      return false;
    }
  } else if (state.restaurant_chain_id !== "") {
    return false;
  } else {
    return true;
  }
};
